<script>
import Layout from '@layout/main'
import { authComputed } from '@store/helpers'
import _findIndex from 'lodash/findIndex'
import ValidDialog from '@components/Dialog/ValidDealer.vue'
import { mapState } from 'vuex'

export default {
  components: {
    Layout,
    ValidDialog,
  },
  data() {
    return {
      menuList: [
        {
          title: '會員設定',
          alias: 'member-setting',
          icon: '<i class="icomoon icon-member"></i>',
          // isCircle: true,
        },
        {
          title: '報名清單',
          alias: 'member-event-list',
          icon: '<i class="icomoon icon-member-list"></i>',
          children: [
            {
              title: '零壹課程',
              alias: 'member-event-list',
              children: [
                {
                  title: '課程詳情',
                  alias: 'member-event-item',
                  isHidden: true,
                },
              ],
            },
            {
              title: '零壹活動',
              alias: 'member-activity-list',
              children: [
                {
                  title: '活動詳情',
                  alias: 'member-activity-item',
                  isHidden: true,
                },
              ],
            },
          ],
        },
        {
          title: '上課卷',
          alias: 'member-coupon-list',
          icon: '<i class="fal fa-ticket-alt"></i>',
          isCircle: true,
        },
      ],
      menuActive: this.$route.name,
      isDialogValidVisible: false,
      buttonStyle: 'isStylePrimary isSmall isRadius',
      dialogData: {
        type: 1, // 1 補欄位 2 驗證資格 3 詢問驗證
        title: '補齊欄位資料',
        text1: '請將欄位填寫完畢',
        text2: '並確認公司信箱是否正確',
      },
    }
  },
  computed: {
    ...authComputed,
    ...mapState('auth', {
      companyLevel: (state) => state.companyLevel,
    }),
    mobileMenuList() {
      return [
        {
          title: '會員設定',
          alias: 'member-info',
          canActive: ['member-info', 'member-setting'],
          icon: '<i class="icomoon icon-primary-user"></i>',
          // isCircle: true,
        },
        {
          title: '報名清單',
          alias: 'member-event-list',
          canActive: ['member-event-list', 'member-activity-list'],
          icon: '<i class="icomoon icon-primary-file"></i>',
          // children: [
          //   {
          //     title: '零壹課程',
          //     alias: 'member-event-list',
          //     children: [
          //       {
          //         title: '課程詳情',
          //         alias: 'member-event-item',
          //         isHidden: true,
          //       }
          //     ]
          //   },
          //   {
          //     title: '零壹活動',
          //     alias: 'member-activity-list',
          //     children: [
          //       {
          //         title: '活動詳情',
          //         alias: 'member-activity-item',
          //         isHidden: true,
          //       }
          //     ]
          //   },
          // ]
        },
        {
          title: '上課卷',
          alias: 'member-coupon-list',
          canActive: ['member-coupon-list'],
          icon: '<i class="fal fa-ticket-alt color-primary"></i>',
        },
      ]
    },
    isEventPage() {
      const eventPageMap = ['member-event-list', 'member-activity-list']
      return eventPageMap.includes(this.$route.name)
    },
    filterPage() {
      const bgTransparentPageMap = ['member-info', 'member-setting']
      return bgTransparentPageMap.includes(this.$route.name)
    },
    // memberSettingRoute() {
    //   const routerMap = [
    //     'member-info',
    //     'member-setting',
    //   ]
    //   if(routerMap.includes(this.$route.name)){
    //     return this.$route.name
    //   } else {
    //     return 'member-info'
    //   }

    // }
  },
  methods: {
    hasActiveMenu(menus) {
      return menus.some((menu) => {
        if (menu.alias === this.$route.name) {
          return menu.alias === this.$route.name
        }

        if (menu.children) {
          return this.hasActiveMenu(menu.children)
        }

        return false
      })
    },
    isParent(menu) {
      if (!menu.children) {
        return false
      }

      return this.hasActiveMenu(menu.children)
    },
    hasVisableSubMenu(subMenu) {
      return (
        _findIndex(subMenu, (menu) => {
          return !menu.isHidden
        }) >= 0
      )
    },
    onChangeMenu(value) {
      if (value === 'logout') {
        this.tryToLogout()
        return false
      }
      this.$router.push({
        name: value,
      })
    },
    async tryToLogout() {
      this.loadingLogout = true
      await this.$store
        .dispatch('auth/logOut')
        .then(() => {
          this.$router.push({ name: 'home' })
          // if(this.$route.query?.redirectFrom && this.$route.query?.redirectFrom.indexOf(this.$globalSubSiteUrl)) {
          //   window.location = this.$route.query?.redirectFrom
          // } else {
          //   this.$router.push({ name: 'home' });
          // }
        })
        .finally(() => {
          this.loadingLogout = false
        })
    },
    isActive(list) {
      return list.includes(this.$route.name)
    },
    async isDialog(kind) {
      if (kind === 1) {
        this.dialogData = {
          type: 2, // 1 補欄位 2 驗證資格 3 詢問驗證
          title: '收取驗證連結',
          text1: `已發送驗證連結至您的電子郵件${this.currentMember.company.email}`,
          text2: '請點選信件內驗證連結進行升級',
        }
        await this.$store.dispatch('auth/sendDealerVaildEmail')
        this.isDialogValidVisible = true
      } else {
        this.isDialogValidVisible = true
      }
    },
  },
}
</script>
<template>
  <Layout :class="$style.layoutMember">
    <div class="d-md-none layoutMember__menu">
      <div class="layoutMember__menu__boxInner">
        <div class="row layoutMember__menu__list no-gutters">
          <router-link
            v-for="(item, $index) in mobileMenuList"
            :key="$index"
            class="text-center layoutMember__menu__item"
            :class="[`col-${12 / mobileMenuList.length}`, { isActive: isActive(item.canActive) }]"
            :to="{ name: item.alias }"
          >
            {{ item.title }}
          </router-link>
        </div>
      </div>
    </div>
    <slot name="banner" />
    <div class="container">
      <div class="row">
        <div class="layoutMember__left col-lg-3 col-12 section d-md-block d-none">
          <div class="mb-3 text-lg-left text-center">
            <span class="text-xl">Hello,</span>
            <br class="d-block d-md-none" />
            <span class="text-xl color-primary ml-2">
              <template v-if="currentMember && currentMember.name">{{ currentMember.name }}</template>
              <template v-else>零壹會員</template>
            </span>
          </div>
          <template v-if="currentMember.group === '經銷會員' && currentMember.dealerValidate === false">
            <div class="mb-2 text-center memberBack warningLevel"> 經銷會員未驗證 </div>
          </template>
          <template v-else-if="currentMember.group === '經銷會員' && currentMember.dealerValidate && currentMember.dealerExpired">
            <div class="mb-2 text-center memberBack warningLevel"> 經銷會員已過期</div>
          </template>
          <template v-else>
            <div :class="currentMember.group === '經銷會員' ? 'dealerLevel' : 'normalLevel'" class="mb-2 text-center memberBack"> {{ currentMember.group }} </div>
          </template>
          <template v-if="currentMember.group === '經銷會員' && currentMember.dealerValidate === false">
            <div class="mb-2 text-center ready-verify">－已具備經銷資格請驗證－</div>
          </template>
          <template v-if="currentMember.group === '經銷會員' && currentMember.dealerValidate && currentMember.dealerExpired">
            <div class="mb-2 mt-2 text-center ready-verify">－請重新驗證－</div>
          </template>
          <template v-if="!currentMember.dealerValidate && companyLevel !== '一般'">
            <template v-if="currentMember.group === '經銷會員' && currentMember.dealerValidate === false">
              <BaseButton class="valid" :class="buttonStyle" @click="isDialog(1)"> 立即驗證 > Go </BaseButton>
            </template>
            <template v-else>
              <BaseButton class="valid" :class="buttonStyle" @click="isDialog(2)"> 驗證成為經銷會員 </BaseButton>
            </template>
          </template>
          <template v-else>
            <template v-if="currentMember.group === '經銷會員' && currentMember.dealerValidate && currentMember.dealerExpired">
              <BaseButton class="valid" :class="buttonStyle" @click="isDialog(1)"> 立即驗證 > Go </BaseButton>
            </template>
          </template>
          <hr class="hr" />
          <!-- 手機 -->
          <div class="d-lg-none">
            <el-select v-model="menuActive" placeholder="請選擇" class="isStyleMenu mb-12" @change="onChangeMenu">
              <template v-for="(menu, index) in menuList">
                <template v-if="menu.children && hasVisableSubMenu(menu.children)">
                  <template v-for="(submenu, index2) in menu.children">
                    <template v-if="!submenu.isHidden">
                      <el-option :key="index + ' ' + index2" :value="submenu.alias" :label="submenu.title">
                        <span class="mr-2" v-html="menu.icon"></span>
                        <span class="text-h5 mr-2">{{ menu.title }}</span> <span class="text-h6">{{ submenu.title }}</span>
                      </el-option>
                    </template>
                  </template>
                </template>
                <template v-else>
                  <el-option :key="index + 'menu'" :value="menu.alias" :label="menu.title">
                    <span class="mr-2" v-html="menu.icon"></span>
                    <span class="text-h5">{{ menu.title }}</span>
                  </el-option>
                </template>
              </template>
              <el-option value="logout" label="登出會員">
                <i class="icomoon icon-primary-logout mr-2"></i>
                <span class="text-h5">登出會員</span>
              </el-option>
            </el-select>
          </div>
          <!-- 桌機版 -->
          <ul :class="$style.menuList" class="d-lg-block d-none">
            <li v-for="(menu, index) in menuList" :key="`menu-${index}`" class="menuList__item">
              <router-link v-if="!menu.isHidden" :to="{ name: menu.alias }" class="menuList__link" :class="{ [$style.isActive]: isParent(menu) }">
                <div class="menuList__icon" :class="{ isCircle: menu.isCircle }" v-html="menu.icon"></div>
                <span class="menuList__text">{{ menu.title }}</span>
              </router-link>
              <ul v-if="isParent(menu)" class="menuList__subMenu">
                <li v-for="(submenu, index2) in menu.children" :key="index2" class="menuList__subMenu__item">
                  <router-link v-if="!submenu.isHidden" :key="`submenu-${index2}`" :to="{ name: submenu.alias }" class="menuList__subMenu__link">
                    {{ submenu.title }}
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="menuList__item">
              <div class="menuList__link" @click="tryToLogout">
                <div class="menuList__icon">
                  <i class="icomoon icon-member-log-out"></i>
                </div>
                <span class="menuList__text">登出會員</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="layoutMember__right col-lg-9 col-12 section" :class="{ isMobileTransparent: filterPage }">
          <div class="layoutMember__rightInner">
            <slot />
          </div>
        </div>
      </div>
      <ValidDialog :visible.sync="isDialogValidVisible" :dialog-data="dialogData" @confirm="isDialogValidVisible = false" />
    </div>
  </Layout>
</template>
<style lang="scss" module>
.layoutMember {
  :global {
    .layoutMember {
      &__menu {
        height: 55px;
        &__boxInner {
          // @include max-md {
          position: fixed;
          top: 48px;
          z-index: 1225;
          width: 100vw;
          background: rgba(255, 255, 255, 0.95);
          box-shadow: 0 10px 20px rgba(33, 69, 88, 0.1);
          transition: top 0.6s;
          backdrop-filter: blur(3px);
          // }
        }
        &__list {
        }
        &__item {
          padding: 25px 0;
          color: $color-gray-7;
          text-decoration: none;

          &:hover {
            color: $color-primary;
          }

          &.router-link-active,
          &.isActive {
            color: $color-primary;
            border-bottom: 4px solid $color-primary;
          }
          @include max-lg {
            padding: 1.25rem 0;
          }
          @include max-md {
            font-size: 0.875rem;
            padding: 0.87125rem;
          }

          &:not(:last-child) {
            position: relative;

            &::before {
              position: absolute;
              top: 50%;
              right: 0;
              width: 1px;
              height: 30%;
              content: '';
              background: $color-gray-3;
              transform: translateY(-50%);
            }
          }

          &:first-child,
          &:last-child {
            position: relative;

            &::after {
              position: absolute;
              top: 50%;
              width: 1px;
              height: 30%;
              content: '';
              background: $color-gray-3;
              transform: translateY(-50%);
            }
            @include max-lg {
              &:after {
                display: none;
              }
            }
          }

          &:first-child {
            &::after {
              left: 0;
            }
          }

          &:last-child {
            &::after {
              right: 0;
            }
          }
        }
      }
      &__left {
        @include unstyled;
        .memberBack {
          color: $color-gray-4;
          font-size: 16px;
          border-radius: 5px;
          padding: 5px;
          width: 220px;
          @include max-lg {
            width: 100%;
          }
        }
        .valid {
          width: 220px;
          @include max-lg {
            width: 100%;
          }
        }
        .ready-verify {
          width: 230px;
          font-size: 16px;
          color: $color-gray-4;
        }
        .hr {
          width: 220px;
          margin: 42px 0px;
          @include max-lg {
            width: 100%;
          }
        }
        .normalLevel {
          border: 1px solid $color-gray-3;
        }
        .dealerLevel {
          border: 1px solid $color-primary;
          color: $color-primary;
        }
        .warningLevel {
          border: 1px solid $color-warning;
          color: $color-warning;
        }
      }

      &__right {
        background: transparent linear-gradient(180deg, #f5f5f5 0%, #f5f5f5 100%) 0% 0% no-repeat padding-box;
        @include max-md {
          padding-top: 1.5rem;
          // @include var-height(100);
          // min-height: calc((var(--vh, 1vh) * 100) - 163px );
          height: auto;
        }
        &.isMobileTransparent {
          @include max-md {
            background: transparent;
          }
        }
      }

      &__rightInner {
        padding: 0 2rem;

        @include max-lg {
          padding: 0 0 2rem 0;
        }
      }
    }
  }
}

.menuList {
  @include list-unstyled;

  :global {
    .menuList {
      &__item {
        &:not(:last-child) {
          margin-bottom: 1rem;
        }
      }

      &__link {
        display: flex;
        align-items: center;
        color: #525a67;
        cursor: pointer;
        opacity: 0.5;

        &:hover {
          text-decoration: none;
          opacity: 0.75;
        }

        &.router-link-active {
          opacity: 1;
        }
      }

      &__icon {
        display: inline-block;
        margin-right: 0.5rem;
        // width: 30px;
        // height: 30px;
        font-size: 26px;

        &.isCircle {
          width: 26px;
          height: 26px;
          font-size: 15px;
          line-height: 25px;
          text-align: center;
          background-repeat: no-repeat;
          background-position: center;
          background-size: 50%;
          border: 1px solid;
          border-radius: 100%;

          i {
            letter-spacing: 0;
          }
        }
      }

      &__text {
      }

      &__subMenu {
        @include list-unstyled;

        margin-top: 0.5rem;

        &__item {
          padding-left: 2.4rem;
          margin-top: 0.5rem;
        }

        &__link {
          display: flex;
          align-items: center;
          color: #525a67;
          cursor: pointer;
          opacity: 0.5;

          &:hover {
            text-decoration: none;
            opacity: 0.75;
          }

          &.router-link-active {
            color: $color-primary;
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
